<script>
  import NumberInput from 'components/NumberInput/NumberInput';
  import CheckboxInput from 'components/CheckboxInput/CheckboxInput';
  import { onMount, onDestroy } from 'svelte';
  import draft from 'stores/Draft';
  import selection from '../../Selection/SelectionStore';
  import * as draftUtil from 'util/DraftUtil';
  import ui from 'stores/UI';
  import { t } from 'precompile-intl-runtime';

  $: useThreading = $selection.useThreading;
  $: useTreadleOrder = $selection.useTreadleOrder;
  $: useWarpColors = $selection.useWarpColors;
  $: useWeftColors = $selection.useWeftColors;
  $: maxLength = Math.max($draft.warpCount, $draft.weftCount);
  $: selectionFrom = $selection.from;
  $: selectionTo = $selection.to;
  $: targetFrom = 0;
  $: targetTo = maxLength;
  let fillAll = true;

  $: {
    selection.update((temp) => {
      temp.useThreading = useThreading;
    });
  }

  $: {
    selection.update((temp) => {
      temp.useTreadleOrder = useTreadleOrder;
    });
  }

  $: {
    selection.update((temp) => {
      temp.useWarpColors = useWarpColors;
    });
  }

  $: {
    selection.update((temp) => {
      temp.useWeftColors = useWeftColors;
    });
  }

  onMount(() => {
    selection.update((temp) => {
      temp.isSelecting = true;
    });
  });

  onDestroy(() => {
    selection.update((temp) => {
      temp.isSelecting = false;
    });
  });

  function submit(event) {
    event.preventDefault();
    draft.update((temp) => {
      if (useThreading) {
        draftUtil.applyPattern(
          temp,
          $draft.threading.slice(selectionFrom[0], selectionTo[0]),
          'warp',
          false,
          targetFrom,
          targetTo
        );
      }

      if (useWarpColors) {
        draftUtil.applyColor(
          temp,
          $draft.warpColors.slice(selectionFrom[0], selectionTo[0]),
          'warp'
        );
      }

      if (useTreadleOrder) {
        draftUtil.applyPattern(
          temp,
          $draft.treadleOrder.slice(selectionFrom[1], selectionTo[1]),
          'weft',
          false,
          targetFrom,
          targetTo
        );
      }

      if (useWeftColors) {
        draftUtil.applyColor(
          temp,
          $draft.weftColors.slice(selectionFrom[1], selectionTo[1]),
          'weft'
        );
      }
    });
  }

  function close() {
    ui.update((temp) => {
      temp.selectedMenu = -1;
    });
  }
</script>

<div>
  <fieldset class="repeat-options">
    <legend>{$t('page.selection.title')}</legend>

    <CheckboxInput label={$t('terms.threading')} bind:checked={useThreading} />
    <CheckboxInput
      label={$t('terms.treadleOrder')}
      bind:checked={useTreadleOrder}
    />
    <CheckboxInput label={$t('terms.warp')} bind:checked={useWarpColors} />
    <CheckboxInput label={$t('terms.weft')} bind:checked={useWeftColors} />
  </fieldset>
  <legend>Target</legend>
  <fieldset class="to-from-inputs">
    <div>
      <label for="fill-all">{$t('page.selection.fillAll')}</label>
      <input
        name="fill-all"
        id="fill-all"
        type="checkbox"
        bind:checked={fillAll}
      />
    </div>

    <NumberInput label="From" min="0" max={maxLength} bind:value={targetFrom} />
    <NumberInput
      label={$t('page.selection.to')}
      min="0"
      max={maxLength}
      disabled={fillAll}
      bind:value={targetTo}
    />
  </fieldset>
  <div class="buttons">
    <button class="submit" on:click={submit}>Apply repetition</button>
    <button class="submit" on:click={close}>Close</button>
  </div>
</div>

<!--
<form on:submit={submit} class="controls">
</form>
-->
<style>
  fieldset {
    margin-bottom: 10px;
    border: none;
  }

  fieldset > *:not(legend) {
    margin-left: 12px;
  }

  legend {
    font-size: 1.5rem;
  }

  label {
    margin-right: 10px;
    display: flex;
    align-items: center;
  }

  .to-from-inputs input {
    margin: 5px 0;
    width: 5rem;
  }

  .repeat-options {
    display: grid;
    grid-template-columns: 1fr;
  }

  .buttons {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
